import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { OrderLog } from 'types/embedded/orderLog';

type Props = Omit<FunctionFieldProps, 'render' | 'source'>;

export const OrdersShowLogsDirectionField: React.FC<Props> = (props) => {
  const translate = useTypedTranslate();

  return (
    <FunctionField
      render={(record: OrderLog) => (
        <Stack>
          <Typography color="secondary" variant="body2">
            {translate('app.orders.logs.direction')}
          </Typography>
          <Typography variant="body2">{record?.direction}</Typography>
        </Stack>
      )}
      sortable={false}
      {...props}
    />
  );
};
